import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getJob, setJob, getPoints, getApiUrl } from '../../redux/Actions';
import { Col, Form, Button, Card, Modal } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import GoogleMapReact from 'google-map-react';
import Loader from 'react-loader-spinner';
import GooglePlacesAutocomplete, { geocodeByPlaceId } from 'react-google-places-autocomplete';
// If you want to use the provided css
import 'react-google-places-autocomplete/dist/assets/index.css';

import './Map.css';
import carIcon from './img/lock.png';
import selfIcon from './img/target.png';


const CarPointer = ({ text }) => <div className="car_pointer">
    <img src={carIcon} style={{ height: "48px", width: "48px" }} />
    <Button variant="primary" size="sm">{text}</Button>
</div>;

const SelfPointer = ({ text }) => <div className="car_pointer">
    <img src={selfIcon} style={{ height: "48px", width: "48px" }} /><br />
    <Button variant="success" size="sm">{text}</Button>
</div>;

const googleKey = 'AIzaSyCMufPUEmRp51wkzkc8JODFtoUAX4MvePc';

export const getAddressObject = data => {
    let address = { street: '' };
    for (let component of data.address_components) {
        if (component.types[0] === "locality") {
            address.city = component.long_name
        } else if (component.types[0] === "administrative_area_level_1") {
            address.state = component.short_name
        } else if (component.types[0] === "postal_code") {
            address.zip = component.long_name
        }
        else if (component.types[0] === "street_number" || component.types[0] === "route") {
            address.street += component.long_name + ' '
        }
    }
    address.address = data.formatted_address;
    return address
};

class Map extends Component {
    constructor(props) {
        super(props)
        this.state = {
            body_class: ['apps-gotlocked-order'],
            currentLatLng: {
                lat: 40.730610,
                lng: -73.935242
            },
            pointers: null,
            isMarkerShown: false,
            zoom: 11,
            showModal: false,
            modalTitle: '',
            modalContent: '',
            showInfo: false,

            job: null,

            address: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            firstname: '',
            lastname: '',

            address_ref: null,
            address2_ref: null,
            city_ref: null,
            state_ref: null,
            zip_ref: null,

            firstname_ref: null,
            lastname_ref: null,


            redirect: false,
            goback: false,
            formClass: 'addressForm',
            loader: true
        }
        this.props.getJob();
    }

    componentWillMount() {
        document.body.classList.add(...this.state.body_class);
        this.getGeoLocation();
        this.getPointers();
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            if (typeof this.props.job === "undefined" || this.props.job === null) {
                this.setState({
                    goback: true
                });
            }
            this.setState({
                loader: false
            });
        }
        if (typeof this.props.job === "undefined" || this.props.job === null) {
            this.setState({
                goback: true
            });
        }
        if (this.state.job === null && this.state.job !== this.props.job) {
            this.setState({
                job: this.props.job,
                address: this.props.job.address.address,
                city: this.props.job.address.city,
                state: this.props.job.address.state,
                zip: this.props.job.address.zip,
                name: this.props.job.address.name,
                firstname: this.props.job.address.firstname,
                lastname: this.props.job.address.lastname
            });
        }
    }

    componentDidMount() {
        if (typeof this.props.job !== "undefined") {
            this.setState({
                loader: false
            });
        }
        this.delayedShowMarker();
    }

    setAddressModalShow() {
        this.setState({ showModal: true });
    }

    hideModal() {
        this.setState({ showModal: false });
    }

    hideInfoModal() {
        this.setState({ showInfo: false });
    }

    delayedShowMarker = () => {
        setTimeout(() => {
            this.setState({ isMarkerShown: true })
        }, 5000)
    }

    getGeoLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.setState(prevState => ({
                        currentLatLng: {
                            ...prevState.currentLatLng,
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        }
                    }));
                    this.updateAddress(position.coords.latitude, position.coords.longitude);
                }
            )
        }
    }

    async getPointers() {
        //let points = [{ key: 1, type: "self", lat: this.state.currentLatLng.lat, lng: this.state.currentLatLng.lng, text: "I`m here" }];
        let data = await getPoints(this.state.currentLatLng.lat, this.state.currentLatLng.lng);
        //let points = await (await fetch(getApiUrl() + '/tech/getpoints')).json();
        //const json = await fetch('https://api.com/values/1').then(response => response.json());
        let output = data.points.map(place => {
            if (place.type === "self") {
                return <SelfPointer key={place.key} lat={place.lat} lng={place.lng} text={place.text} />;
            } else {
                return <CarPointer key={place.key} lat={place.lat} lng={place.lng} text={place.text} />;
            }
        });
        this.setState({
            pointers: output
        });
    }

    async updateAddress(lat, lng, _address = null) {
        let address_parsed = null;
        this.setState({
            address: '',
            city: '',
            state: '',
            zip: ''
        });
        if (_address) {
            address_parsed = _address;
        } else {
            let url = getApiUrl() + `techs/getaddress?latlng=${lat},${lng}`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });
            const json = await response.json();
            if (json && json.response) {
                address_parsed = json.response.results[0];
            }
            // 1let url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleKey}`;
            // fetch(url).then(res => res.json()).then(parsedRes => {
            //   1parsedRes = JSON.parse(JSON.stringify(parsedRes));
            // });
        }
        if (address_parsed)  {
            let address = getAddressObject(address_parsed);
            this.setState({
                address: address.street,
                city: address.city,
                state: address.state,
                zip: address.zip
            });
        }
        this.getPointers();
        this.validate();
        if (this.state.firstname_ref) {
            this.state.firstname_ref.focus();
        }
    }

    updateAdressAutocomplete(address) {
        geocodeByPlaceId(address.place_id)
            .then(results => {
                let _lat = results[0].geometry.location.lat();
                let _lng = results[0].geometry.location.lng();
                this.setState({
                    currentLatLng: { lat: _lat, lng: _lng }
                });
                this.updateAddress(_lat, _lng,  results[0]);
            }).catch(error => console.log(error));
    }

    _onMapClick = (data) => {
        this.setState({
            currentLatLng: { lat: data.lat, lng: data.lng }
        });
        this.updateAddress(data.lat, data.lng);
    }

    _onChildClick(key, childProps) {
        if (parseInt(key, 10) !== 1) {
            this.setState({
                modalTitle: childProps.text,
                modalContent: <Card>
                    <Card.Body>
                        <Card.Title>Techinician: {childProps.text}</Card.Title>
                        <Card.Text>
                            Total jobs:
                            Rate:
                            Quick info:    
                        </Card.Text>
                    </Card.Body>
                </Card>,
                showModal: true
            });
        }
    }

    validate() {
        var error = false;
        if (this.state.address === '') {
            this.state.address_ref.classList.add('error');
            error = true;
        } else {
            this.state.address_ref.classList.remove('error');
        }
        if (this.state.city === '') {
            this.state.city_ref.classList.add('error');
            error = true;
        } else {
            this.state.city_ref.classList.remove('error');
        }
        if (this.state.state === '') {
            this.state.state_ref.classList.add('error');
            error = true;
        } else {
            this.state.state_ref.classList.remove('error');
        }
        if (this.state.zip === '') {
            this.state.zip_ref.classList.add('error');
            error = true;
        } else {
            this.state.zip_ref.classList.remove('error');
        }
        if (this.state.firstname === '') {
            this.state.firstname_ref.classList.add('error');
            error = true;
        } else {
            this.state.firstname_ref.classList.remove('error');
        }
        if (this.state.lastname === '') {
            this.state.lastname_ref.classList.add('error');
            error = true;
        } else {
            this.state.lastname_ref.classList.remove('error');
        }
        return error;
    }

    gotoPayment() {
        if (this.validate() === false) {
            let updated_address = {
                address: this.state.address,
                apartment: this.state.address2,
                location_lng: this.state.currentLatLng.lng,
                location_lat: this.state.currentLatLng.lat,
                city: this.state.city,
                zip: this.state.zip,
                state: this.state.state,
                name: this.state.firstname + ' ' + this.state.lastname,
                firstname: this.state.firstname,
                lastname: this.state.lastname,
            };
            this.state.job['address'] = updated_address;
            this.setState(prevState => ({
                job: {
                    ...prevState.job,
                    address: updated_address
                },
                redirect: true
            }));
            this.props.setJob(null);
            this.props.setJob(this.state.job);
        }
    }

    render() {
        if (this.state.redirect) {
            return (<Redirect push to='/payment' />);
        }
        if (this.state.goback) {
            return (<Redirect push to='/order' />);
        }
        return (
            <div>
                <Loader
                    type="Watch"
                    color="#fcae4b"
                    height={100}
                    width={100}
                    visible={this.state.loader}
                    className="loader"
                />
                <div style={{ height: '67vh', width: '100%' }}>
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: googleKey }}
                        onClick={this._onMapClick}
                        onChildClick={(key, childProps) => this._onChildClick(key, childProps)}
                        defaultCenter={this.state.currentLatLng}
                        center={this.state.currentLatLng}
                        defaultZoom={this.state.zoom}
                        zoom={this.state.zoom}>
                        {this.state.pointers}
                    </GoogleMapReact>
                </div>
                <div className={this.state.formClass}>
                    <Form>
                        <GooglePlacesAutocomplete
                            placeholder="Type your address"
                            onSelect={(address) => this.updateAdressAutocomplete(address)}
                            autoComplete="none"
                            renderInput={(props) => (
                                <div className="custom-wrapper" key="1">
                                    <input
                                        {...props}
                                        style={{ width: '100%' }}
                                        className="google-places-autocomplete__input"
                                        autoComplete="none"
                                    />
                                </div>
                            )}
                            autocompletionRequest={{
                                componentRestrictions: {
                                    country: ['us'],
                                }
                            }}
                        />
                        <Form.Group>
                            <Form.Label>Address</Form.Label>
                            <Form.Control placeholder="" defaultValue={this.state.address} onChange={(e) => { this.setState({ address: e.target.value }); this.validate(); }} ref={(input) => { this.state.address_ref = input; }} />
                        </Form.Group>

                        <Form.Group controlId="formGridAddress2">
                            <Form.Label>Address 2</Form.Label>
                            <Form.Control defaultValue={this.state.address2} onChange={(e) => { this.setState({ address2: e.target.value }); this.validate(); }} ref={(input) => { this.state.address2_ref = input; }} />
                        </Form.Group>

                        <Form.Row>
                            <Form.Group as={Col} controlId="formGridCity">
                                <Form.Label>City</Form.Label>
                                <Form.Control defaultValue={this.state.city} onChange={(e) => { this.setState({ city: e.target.value }); this.validate(); }} ref={(input) => { this.state.city_ref = input; }} />
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridState">
                                <Form.Label>State</Form.Label>
                                <Form.Control as="select" value={this.state.state} onChange={(e) => { this.setState({ state: e.target.value }); this.validate(); }} ref={(input) => { this.state.state_ref = input; }}>
                                    <option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District Of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option><option value="PR">Puerto Rico</option><option value="VI">Virgin Islands</option><option value="MP">Northern Mariana Islands</option><option value="GU">Guam</option><option value="AS">American Samoa</option><option value="PW">Palau</option><option value="AA">Armed Forces (AA)</option><option value="AE">Armed Forces (AE)</option><option value="AP">Armed Forces (AP)</option>
                                </Form.Control>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridZip">
                                <Form.Label>Zip</Form.Label>
                                <Form.Control defaultValue={this.state.zip} onChange={(e) => { this.setState({ zip: e.target.value }); this.validate(); }} ref={(input) => { this.state.zip_ref = input; }} />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="formGridFirstName">
                                <Form.Label>FirstName</Form.Label>
                                <Form.Control defaultValue={this.state.firstname} onChange={(e) => { this.setState({ firstname: e.target.value }); this.validate(); }} ref={(input) => { this.state.firstname_ref = input; }} />
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridLastName">
                                <Form.Label>LastName</Form.Label>
                                <Form.Control defaultValue={this.state.lastname} onChange={(e) => { this.setState({ lastname: e.target.value }); this.validate(); }} ref={(input) => { this.state.lastname_ref = input; }} />
                            </Form.Group>
                        </Form.Row>
                        <div className="text-center">
                            <Button variant="success" onClick={() => this.gotoPayment()}>
                                To Payment
                            </Button>
                        </div>
                    </Form>
                </div>
                <Modal show={this.state.showModal} aria-labelledby="contained-modal-title-vcenter" onHide={() => this.hideModal()}>
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {this.state.modalTitle}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.modalContent}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.hideModal()} variant="secondary">Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const job = state.job;
    return { job };
};

export default connect(mapStateToProps, { getJob, setJob, getPoints })(Map);